import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Browser from '@wetransfer/concorde-browser';

import I18n from '@module/i18n';

import Assets from '@app/assets';
import Helper from '@app/helper';

import Analytics from '@module/analytics';

const UpsellCollectHeader = ({ shortUrl }) => {
  const handleClick = useCallback(() => {
    Analytics.trackSnowplowEvent({
      category: 'transfer',
      action: 'click_open_in_app',
      property: 'large-header',
    });
  }, []);

  if (!Browser.isMobile || !shortUrl) {
    return null;
  }

  return (
    <div className="downloader__collect-header">
      <img
        src={Assets.lookup('receiving-collect-icon.png')}
        alt="Collect logo"
        width="130px"
        height="141px"
      />
      <h3>{I18n.t('notification.mobile_app_banner_title')}</h3>
      <p>{I18n.t('notification.collect_app_banner_desc')}</p>
      <a
        onClick={handleClick}
        title={I18n.t('transfer.buttons.openincollectapp')}
        className="button button--enabled"
        href={
          Helper.getOpenInAppUri({
            shortUrl,
            utmContent: 'large-header',
          }).href
        }
      >
        {I18n.t('transfer.buttons.openincollectapp')}
      </a>
    </div>
  );
};

UpsellCollectHeader.propTypes = {
  shortUrl: PropTypes.string,
};

export default React.memo(UpsellCollectHeader);
